(function () {
  const root = document.querySelector('[data-je-available-filter]');
  const landing = document.querySelector('[data-je-available-landing]');
  const products = document.querySelector('[data-je-available-products]');
  const items = Array.from(document.querySelectorAll('[data-je-filter-item]'));
  const empty = document.querySelector('[data-je-filter-empty]');
  const status = document.querySelector('[data-je-filter-status]');
  const categoryIntro = document.querySelector('[data-je-available-category-intro]');
  const categoryHeading = categoryIntro
    ? categoryIntro.querySelector('[data-je-cat-heading]')
    : null;
  const categorySub = categoryIntro
    ? categoryIntro.querySelector('[data-je-cat-sub]')
    : null;
  const categoryButtons = root ? Array.from(root.querySelectorAll('[data-je-filter]')) : [];
  const availabilityButtons = root ? Array.from(root.querySelectorAll('[data-je-availability]')) : [];

  const allowedCategories = new Set(['vessels', 'planters', 'tables']);
  const categoryMeta = {};
  document.querySelectorAll('[data-je-cat-key]').forEach((el) => {
    const key = el.getAttribute('data-je-cat-key');
    if (!key) return;
    categoryMeta[key] = {
      title: el.getAttribute('data-je-cat-title') || key,
      sub: el.getAttribute('data-je-cat-subtitle') || '',
    };
  });
  const categoryLabels = {
    vessels: (categoryMeta.vessels && categoryMeta.vessels.title) || 'vessels & vases',
    planters: (categoryMeta.planters && categoryMeta.planters.title) || 'planters',
    tables: (categoryMeta.tables && categoryMeta.tables.title) || 'ceramic tables',
  };

  function normalizeCategory(raw) {
    const value = (raw || '').toLowerCase();
    if (value === 'vases' || value === 'vessel' || value === 'vessels-vases') return 'vessels';
    if (value === 'planter') return 'planters';
    if (value === 'table' || value === 'ceramic-tables' || value === 'ceramic_tables') return 'tables';
    return allowedCategories.has(value) ? value : '';
  }

  function normalizeAvailability(raw, legacyAvailable) {
    let value = (raw || '').toLowerCase();
    if (legacyAvailable === '1' || legacyAvailable === 'true') value = 'in-stock';
    if (value === 'in' || value === 'stock') value = 'in-stock';
    if (value === 'in-stock' || value === 'all') return value;
    return 'all';
  }

  function readState() {
    const params = new URLSearchParams(window.location.search);
    return {
      category: normalizeCategory(params.get('category')),
      availability: normalizeAvailability(params.get('availability') || params.get('stock'), params.get('available')),
    };
  }

  function writeState(category, availability) {
    const url = new URL(window.location.href);
    if (category) {
      url.searchParams.set('category', category);
    } else {
      url.searchParams.delete('category');
    }
    if (availability && availability !== 'all') {
      url.searchParams.set('availability', availability);
    } else {
      url.searchParams.delete('availability');
    }
    url.searchParams.delete('available');
    url.searchParams.delete('stock');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  function setView(category) {
    const mode = category ? 'category' : 'landing';
    document.documentElement.setAttribute('data-je-aw', mode);
    if (landing) landing.hidden = Boolean(category);
    if (products) products.hidden = !category;
  }

  function updateCategoryIntro(category) {
    if (!categoryIntro || !categoryHeading) return;
    if (!category) {
      categoryHeading.textContent = '';
      if (categorySub) {
        categorySub.textContent = '';
        categorySub.hidden = true;
      }
      return;
    }
    const meta = categoryMeta[category] || {};
    const title = meta.title || categoryLabels[category] || category;
    categoryHeading.textContent = title;
    if (categorySub) {
      if (meta.sub) {
        categorySub.textContent = meta.sub;
        categorySub.hidden = false;
      } else {
        categorySub.textContent = '';
        categorySub.hidden = true;
      }
    }
  }

  function applyFilters(category, availability) {
    setView(category);
    updateCategoryIntro(category);
    if (!category) return;

    let visible = 0;

    items.forEach((item) => {
      const groups = (item.getAttribute('data-je-filter-item') || 'other').split(/\s+/);
      const inStock = item.getAttribute('data-je-in-stock') !== 'false';
      const categoryMatch = groups.indexOf(category) !== -1;
      const availabilityMatch = availability === 'all' || (availability === 'in-stock' && inStock);
      const show = categoryMatch && availabilityMatch;
      item.hidden = !show;
      if (show) visible += 1;
    });

    categoryButtons.forEach((button) => {
      const active = button.getAttribute('data-je-filter') === category;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    availabilityButtons.forEach((button) => {
      const active = button.getAttribute('data-je-availability') === availability;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (empty) {
      empty.hidden = visible > 0;
      if (availability === 'in-stock') {
        empty.textContent = 'No in-stock pieces in this category right now.';
      } else {
        empty.textContent = 'No pieces in this category right now.';
      }
    }

    if (status) {
      const label = categoryLabels[category] || category;
      if (availability === 'in-stock') {
        status.textContent = `Showing ${visible} in-stock ${label}`;
      } else {
        status.textContent = `Showing ${visible} ${label}`;
      }
    }
  }

  let { category, availability } = readState();
  applyFilters(category, availability);

  availabilityButtons.forEach((button) => {
    button.addEventListener('click', () => {
      availability = button.getAttribute('data-je-availability') || 'all';
      writeState(category, availability);
      applyFilters(category, availability);
    });
  });
})();
